import Reveal from "@/components/Reveal";
import { EXPERIENCE } from "@/lib/site";

const slug = (s) => s.replace(/[^a-z]+/gi, "-").toLowerCase();

export default function Experience() {
  return (
    <section id="experience" className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.3em] text-fog">02 // EXPERIENCE</p>
          <h2 className="mt-6 max-w-3xl font-display text-4xl font-black tracking-tight text-white sm:text-5xl">
            Named employers. Real hardware.
          </h2>
        </Reveal>

        <div className="mt-16">
          {EXPERIENCE.map((job, i) => (
            <Reveal key={job.company} delay={i * 0.05}>
              <div
                data-testid={`experience-${slug(job.company)}`}
                className="group grid grid-cols-1 gap-4 border-t border-white/10 py-10 transition-colors duration-300 last:border-b hover:bg-white/[0.02] md:grid-cols-12 md:items-baseline md:gap-8 md:py-12"
              >
                <div className="font-mono text-xs text-fog md:col-span-1">0{i + 1}</div>
                <div className="md:col-span-5">
                  <h3 className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
                    {job.company}
                  </h3>
                  <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-fog">{job.role}</p>
                </div>
                <div className="text-sm leading-relaxed text-fog sm:text-base md:col-span-6">
                  {job.impact.map((part, j) =>
                    part.stat ? (
                      <span key={j} className="mx-1 font-mono text-xl font-medium text-white sm:text-2xl">
                        {part.t}
                      </span>
                    ) : (
                      <span key={j}>{part.t}</span>
                    ),
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <p className="mt-8 font-mono text-[10px] tracking-[0.2em] text-fog">
          * SELECTED ENGAGEMENTS — FULL DETAIL IN THE RÉSUMÉ PDF
        </p>
      </div>
    </section>
  );
}
